// Barrel export for OBS comparison images with standardized names
export { default as streamyardView } from './streamyardView.png';
export { default as competitorView } from './obsView.png';
